const localStorageKeys = {
  TOKEN: 'Token',
  IDB_VERSION: 'IDB_VER',
  LOCALIZE: 'HW.LANG',
  USER_TYPE: 'UserType',
  THEME: 'THEME',
  LEARNING_CONFIG: 'LearningConfig',
  DURATION_CALENDAR: 'DurationCalendar',
  SCHOOL_EXAM_PERIOD_MONTH_FILTER: 'SchoolExamPeriodMonthFilter',
  SCHOOL_EXAM_PERIOD_OVERVIEW_MONTH_FILTER: 'SchoolExamPeriodOverviewMonthFilter',
  SCHOOL_EXAM_PERIOD_MARK_MONTH_FILTER: 'SchoolExamPeriodMarkMonthFilter',
  SCHOOL_YEAR_DATA: 'SchoolYearData',
  SCHOOL_YEAR: 'SchoolYear'
}

const sessionStorageKeys = {
  CLASSROOM: 'classroom',
  LOGIN_STUDENT: 'LoginStudent',
  IS_LOGIN_FROM_LMS: 'IsLoginFromLMS',
  DASHBOARD_BACKGROUND: 'DashboardBackground',
  TEACHER_USING_APP: 'TeacherUsingApp',
  STUDENT_PACKAGE_DETAIL: 'studentPackageDetail',
  COMPOSE_ROUTER_BACK: 'composeRouterBack',
  DETAIL_CLASSROOM_ROUTER_BACK: 'detailClassroomRouterBack',
  DETAIL_EXAM_ROUTER_BACK: 'detailExamRouterBack',
  VIDEO_ROUTER: 'videoRouter',
  TEACHER_RANKING: 'teacherRanking',
  TEACHER_GIFT_CARD: 'teacherGiftCard',
  IS_EMIS_ACCOUNT: 'isEmisAccount',
  SELFLEARNING_ROUTER: 'selfLearningRouter',
  CATEGORY_EXPEND: 'categoryExpend',
  IS_JOINED_FORMAL_CLASSROOM: 'isJoinedFormalClassroom'
}

export { localStorageKeys, sessionStorageKeys }
